import React from "react";
import styled from "styled-components";

const display = "flex"

const ModalContainer = styled.div`
    display: ${props => {
            return props.visibility != true ? "none" : "flex"
        }
    };
    visibility: ${props => {
        return props.hide ? "hidden" : "visible"
    }};
    justify-content: center;
    align-items: center;
    margin: 0;
    flex-direction: column;
    opacity: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    border: 0;
    z-index: ${props => {
        return props.hide ? "-1" : "3";
    }};
    touch-action: none;
    animation-name: opacityFadeIn;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-iteration-count: 1;

    @keyframes opacityFadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;
    const Background = styled.div`
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: black;
        opacity: 0.8;
    `;

    const ContentWrapper = styled.div`
        display: flex;
        flex-direction: column;
        z-index: 3;
        height: 90%;
        width: 70vw;
        background-color: white;
        box-shadow: 3px 7px 34px -11px rgba(0,0,0,1);
        -webkit-box-shadow: 3px 7px 34px -11px rgba(0,0,0,1);
        -moz-box-shadow: 3px 7px 34px -11px rgba(0,0,0,1);

        @media (max-width: 1024px){
            height: 90%;
            width: 100%;
        }

        @media (orientation: landscape){
            height: 100%;
        }
        
    `;

        const HeaderWrapper = styled.div`
            display: flex;
            align-content: center;
            justify-content: center;
            position: relative;
            max-width: 100%;
            margin-bottom: 20px;
        `;

            const Title = styled.div`
                display: flex;
                align-items: center;
                justify-content: center;
                height: 9vh;
                width: 75%;
                border-bottom: 1px solid #dbdbdb;
                font-family: "Poppins";
                font-size: 28px;
            `;

            const CloseButtonWrapper = styled.div`
                position: absolute;
                z-index: 3;
                left: 100%;
                transform: translateX(-110%);
            `;

                const CloseButton = styled.div`
                    width: 50px;
                    height: 50px;
                    font-size: 40px;
                    background: none;
                    border: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    &:hover {color: #005E58;}   /* mouse over link */
                    &:focus {color: #005E58;}   /* link has focus */
                `;

        const ElementWrapper = styled.div`
            display: ${display};
            overflow-y: auto;
            justify-content: center;
        `;

export default class CreatorModal extends React.Component{
    constructor(props){
        super(props);

        this.scrollPosition = 0;
    }

    componentDidMount(){
        if(!this.props.hide)
            this.blockBodyFromScroll();
            this.hideScrollTopButton();
    }

    componentWillUnmount(){
        if(!this.props.hide)
            this.allowBodyScroll();
            this.showScrollButton();
    }

    componentDidUpdate(){
        if(this.props.visibility){
            this.blockBodyFromScroll();
            this.hideScrollTopButton(); 
        }else{
            this.allowBodyScroll();
            this.showScrollButton();
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props.visibility != nextProps.visibility ||
            this.props.cropSizeRangeValue != nextProps.cropSizeRangeValue){
            return true;
        }else{
            return false;
        }
    }

    hideScrollTopButton = () => {
        if(window.scrollTop && !window.scrollTop.classList.contains("scrollTop-reactHide")){
            window.scrollTop.classList.add("scrollTop-reactHide");
        }
    }

    blockBodyFromScroll = (e) => {
        this.scrollPosition = document.documentElement.scrollTop;

        if(this.props.scrollPositionToSliderContainerAfterUnmount){
            if(window.innerWidth <= 768)
                this.scrollPosition = window.$(".sliderContainer").offset().top;
        }

        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.position = 'fixed';
        document.documentElement.scrollTop = this.scrollPosition;
        document.documentElement.style.width = '100%';
    }

    showScrollButton = () => {
        if(window.scrollTop && window.scrollTop.classList.contains("scrollTop-reactHide")){
            window.scrollTop.classList.remove("scrollTop-reactHide");
        }
    }

    allowBodyScroll = (e) => {
        document.documentElement.style.removeProperty("overflow");
        document.documentElement.style.removeProperty("position");
        document.documentElement.style.removeProperty("top");
        document.documentElement.style.removeProperty("width");
        document.documentElement.scrollTop = this.scrollPosition;
        // window.scrollTo({
        //     top: this.scrollPosition,
        //     behavior: 'auto'
        // });
        
    }

    closeModal = (e) => {
        this.props.closeModal(e);
    }

    render(){
        const { title, visibility, hide } = this.props;
        let isPureHtml = typeof this.props.content !== "object" ? true : false;
        return(
            <ModalContainer
                visibility={visibility}
                hide={hide}
                id={this.props.id} 
            >
                <Background/>
                <ContentWrapper>
                    <HeaderWrapper>
                        <CloseButtonWrapper>
                            <CloseButton onClick={this.closeModal}>×</CloseButton>
                        </CloseButtonWrapper>
                        <Title>{ title }</Title>
                    </HeaderWrapper>
                    {
                        isPureHtml ?
                        <ElementWrapper dangerouslySetInnerHTML={{__html: this.props.content}}></ElementWrapper>
                        :
                        <ElementWrapper>
                            {
                                this.props.content
                            }
                        </ElementWrapper>
                    }
                    
                </ContentWrapper>
            </ModalContainer>
        )
    }
}